import "./style.less";
export default function calendar() {
    return {
        restrict: "E",
        scope: {
            article: "=",
        },
        replace: false,
        template: require("./template.html"),
        controller: function (
            $scope,
            searchUrl,
            moment,
            $window,
            houseService,
            $location
        ) {
            $scope.viewModeModel = "Kalender";

            $scope.cache = {};

            searchUrl.init().then((res) => {
                $scope.activity = res.activity;
                $scope.location = res.location;
                $scope.CategoryID = res.activity.CategoryID;

                // Init resources (group by resources)
                houseService
                    .getResources($scope.CategoryID)
                    .then((resources) => {
                        $scope.resources = resources.filter((x) => x.isActive);

                        // Get avaiable timeslots (grouped by day)
                        houseService
                            .searchResult(
                                moment(res.date, "DD-MM-YYYY").format(
                                    "YYYY-MM-DD"
                                ),
                                moment(res.date, "DD-MM-YYYY")
                                    .add(14, "days")
                                    .format("YYYY-MM-DD"),
                                $scope.CategoryID
                            )
                            .then((timeslots) => {
                                $scope.timeslots = timeslots;

                                const availabledates = timeslots.map(
                                    (x) =>
                                        `${x.resourceId}_${moment(
                                            x.calendarDate
                                        ).format("YYYY-MM-DD")}`
                                );

                                $scope.availabledates = availabledates;

                                loadDaypilot(res.date);

                                $scope.cache[`${$scope.config.startDate}`] =
                                    availabledates;

                                // Remap resources to tree structure
                                $scope.config.resources = convertListToTree(
                                    $scope.resources
                                );

                                updateCalendarUI();
                            });
                    });
            });

            angular.element($window).on("resize", function () {
                updateCalendarUI();
            });

            function updateCalendarUI() {
                // Mobile
                if ($window.innerWidth < 768) {
                    $scope.config.rowHeaderWidth = 100;
                    $scope.config.rowHeaderWidthAutoFit = false;
                    $scope.config.days = 7;
                    $scope.config.rowMinHeight = 40;
                    $scope.config.treeIndent = "0";
                } else {
                    $scope.config.rowHeaderWidthAutoFit = true;
                    $scope.config.days = 14;
                    $scope.config.rowMinHeight = 30;
                    $scope.config.treeIndent = "1";
                }
            }

            function convertListToTree(unsortedList) {
                const mapTree = {};
                let node = {};
                const roots = [];
                let i = 0;

                const list = unsortedList;

                for (i = 0; i < list.length; i += 1) {
                    list[i].expanded = true;
                    list[i].children = []; // initialize the children
                    mapTree[list[i].id] = i; // initialize the map
                }

                for (i = 0; i < list.length; i += 1) {
                    node = list[i];
                    node.id = node.id.toString();

                    if (!node.isActive) {
                        node.name = `${node.name} (inaktiv)`;
                    }

                    if (node.parentId > 0) {
                        // if you have dangling branches check that map[node.parentId] exists
                        if (list[mapTree[node.parentId]]) {
                            list[mapTree[node.parentId]].children.push(node);
                        }
                    } else {
                        roots.push(node);
                    }
                }

                return roots;
            }

            function loadDaypilot(startdate) {
                $scope.config = {
                    //layout: "DivBased",
                    startDate:
                        startdate === 0
                            ? moment().format("YYYY-MM-DD")
                            : moment(startdate, "DD-MM-YYYY").format(
                                  "YYYY-MM-DD"
                              ),
                    useEventBoxes: "Never",
                    locale: "da-dk",
                    scale: "Day",
                    cellWidthSpec: "Auto",
                    days: 14,
                    treeEnabled: true,
                    treeIndent: "1",
                    treeImageMarginLeft: "0",
                    treeImageMarginTop: "5",
                    timeHeaders: [
                        {
                            groupBy: "Month",
                            format: "MMMM yyyy",
                        },
                        {
                            groupBy: "Day",
                            format: "d ddd",
                        },
                    ],
                    onBeforeRowHeaderRender: function (args) {
                        if (args.row.data.parentId < 0) {
                            args.row.cssClass = "location";
                        }
                    },
                    onBeforeCellRender: function (args) {
                        var start = moment(args.cell.start.value);
                        var resourceId = args.cell.resource;
                        var calDate =
                            resourceId + "_" + start.format("YYYY-MM-DD");

                        // Disable cell default
                        args.cell.disabled = true;
                        args.cell.backColor = "#f5f5f5";

                        // Check if date is avaiable
                        if ($scope.availabledates.indexOf(calDate) != -1) {
                            args.cell.disabled = false;
                            args.cell.cssClass = "available";
                            args.cell.backColor = "#78ac17";
                        }
                    },
                    onTimeRangeSelected: function (args) {
                        const start = moment(args.start.value);
                        const resource = $scope.resources.find((x) => {
                            if (x.id === args.resource) {
                                return x;
                            }

                            // Find in children
                            if (x.children) {
                                return x.children.find(
                                    (c) => c.id === args.resource
                                );
                            }
                        });

                        // Redirect to facility
                        $window.location.assign(
                            `/search/periods/${$scope.activity.Name.toLowerCase()}/${resource.location.name.toLowerCase()}?date=${start.format(
                                "DD-MM-YYYY"
                            )}&resource=${
                                args.resource
                            }&t=${new Date().getTime()}`
                        );
                    },
                };
            }

            function goToXDaysFromToday(days) {
                $scope.config.startDate = moment($scope.config.startDate)
                    .add(days, "days")
                    .format("YYYY-MM-DD");

                if ($scope.cache[`${$scope.config.startDate}`]) {
                    $scope.availabledates =
                        $scope.cache[`${$scope.config.startDate}`];
                    $scope.scheduler.update();
                    return;
                }

                // Get avaiable timeslots (grouped by day)
                houseService
                    .searchResult(
                        moment($scope.config.startDate).format("YYYY-MM-DD"),
                        moment($scope.config.startDate)
                            .add(14, "days")
                            .format("YYYY-MM-DD"),
                        $scope.CategoryID
                    )
                    .then((timeslots) => {
                        $scope.timeslots = timeslots;

                        const availabledates = timeslots.map(
                            (x) =>
                                `${x.resourceId}_${moment(
                                    x.calendarDate
                                ).format("YYYY-MM-DD")}`
                        );

                        $scope.availabledates = availabledates;

                        $scope.cache[`${$scope.config.startDate}`] =
                            availabledates;

                        $scope.scheduler.update();
                    });
            }

            $scope.prev = function () {
                goToXDaysFromToday($scope.config.days * -1);
            };

            $scope.next = function () {
                goToXDaysFromToday($scope.config.days);
            };

            $scope.gotoPeriod = function () {
                houseService.searchFilter.scrollToSearchResults = false;

                const url = `/search/activity/${$scope.activity.Name.toLowerCase()}?date=${moment(
                    $scope.config.startDate
                ).format("DD-MM-YYYY")}&t=${new Date().getTime()}`;

                $location.url(url);
            };
        },
    };
}
